import { render } from "./metaTemplate.vue?vue&type=template&id=43da0880"
import script from "./metaTemplate.vue?vue&type=script&lang=js"
export * from "./metaTemplate.vue?vue&type=script&lang=js"

import "./metaTemplate.vue?vue&type=style&index=0&id=43da0880&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__